import angular from 'angular';
import * as bowser from 'bowser';

import 'angular-gettext';
import 'angular-ui-router';
import 'angular-ui-router/release/stateEvents';
import 'angular-ui-bootstrap';
import 'ng-tags-input';
import 'angular-toastr/dist/angular-toastr.min';
import 'angular-jwt';
import 'angularjs-dropdown-multiselect';
import 'ng-csv';
import 'angular-breadcrumb';
import 'angular-bootstrap-colorpicker';
import 'angular-local-storage';
import '@lordfriend/nya-bootstrap-select';
import 'angular-vs-repeat';
import 'angular-ladda';
import 'angular-drag-and-drop-lists';
import 'angular-moment';
import 'angular-file-upload';
import 'angular-xeditable';
import 'angular-jquery-timepicker';
import 'angular-scroll';
import 'ui-select';

import App from './app';
import Auth from './auth';
import AppSettings from './app.settings';

import appConfigModule from './config.module';
import apiModule from './api/api.module';
import assetDashboardModule from './pages/asset-dashboard/asset-dashboard.module';
import navModule from './pages/global-layouts/navigation/nav.module';
import componentsModule from './components/components.module';
import directivesModule from './directives/directives.module';
import maintenanceModule from './pages/maintenance/maintenance.module';
import accessManagementModule from './pages/access-management/access-management.module';
import appNotificationModule from './pages/app-notifications/app.notifications.module';
import helpModule from './pages/help/help.module';
import mapModule from './pages/map/map-module';
import profileModule from './pages/user-profile/profile.module';
import reportsModule from './pages/reports/reports.module';
import tSeriesModule from './pages/t-series/t-series.module';
import utilModule from './utility/util.module';
import adminModule from './pages/admin/admin.module';
import alertsModule from './pages/alerts/alerts.module';
import serviceModule from './services/service.module';
import equipmentListModule from './equipment/list/equipment.list.module';
import equipmentESNModule from './equipment/esn/equipment.esn.module';
import devicesModule from './pages/devices/devices.module';
import filterModule from './filters/filter.module';
import equipmentFilterModule from './equipment/filters/equipment.filters.module';
import ErrorsModule from './pages/errors/errors.module';
import browserPolicyModule from './pages/browser-policy/browser-policy.module';
import assetDetailsDashboardModule from './equipment/asset-details-dashboard/asset-details-dashboard.module';
import SitesModules from './pages/Sites/sites.module';
import equipmentUpdateModule from './equipment/equipment-update/equipment-update.module';

import EquipmentSearchService from './equipment/services/equipment-search.service';
import conversionService from './app.conversion.service';
import UtilitySevice from './app.utility.service';
import authService from './auth.service';
import AuthInterceptor from './auth.interceptor';
import TimezoneService from './timezone.service';

import DateRangeDirective, {
  DateRangeController,
} from './equipment/components/date-range/date-range.component';
import { EquipmentDetailsComponent } from './equipment/components/equipment-details/equipment-details.component';
import EquipmentFacetFiltersDirective from './equipment/components/equipment-facet-filters.component';
import EquipmentFiltersSummaryDirective from './equipment/components/equipment-filters-summary.component';
import EquipmentImagesDeleteModalController from './equipment/components/images-modal/equipment-images-delete.modal.controller';
import EquipmentImagesModalController from './equipment/components/images-modal/equipment-images.modal.controller';
import PollButtonDirective from './equipment/components/polling/equipment-polling-component';
import EquipmentFiltersDirective from './equipment/equipment-filters.component';
import EquipmentFullFiltersDirective from './equipment/equipment-full-filters.component';
import { FaultCsvComponent } from './pages/alerts/fault-csv/fault-csv.component';
import EquipmentController from './equipment/equipment.controller';
import { EquipmentDetailEditComponent } from './equipment/equipment.detail.edit.controller';
import EquipmentRouteConfig from './equipment/equipment.route';
import EquipmentSearchFactory from './equipment/equipment.search.factory';
import SaveFiltersConfirmModalController from './equipment/savedfilters/save-filters-confirm-modal.controller';
import SaveFiltersModalController from './equipment/savedfilters/save-filters-modal.controller';
import SavedFiltersDeleteModalController from './equipment/savedfilters/saved-filters-delete-modal.controller';
import SavedFiltersModalController from './equipment/savedfilters/saved-filters-modal.controller';
import SecurityGroupsFilterDirective from './equipment/security-groups-filter.component';
import EquipmentDetailsService from './equipment/services/equipment-details.service';
import ToggleHelpNavDirective from './pages/help/toggle-nav.directive';
import AppController from './main/app.controller';
import IndexRouteConfig from './main/index.route';
import AppSettingsService from './app.settings.service';

const appModule = angular.module('app', [
  appConfigModule,
  componentsModule,
  navModule,
  profileModule,
  maintenanceModule,
  accessManagementModule,
  mapModule,
  reportsModule,
  tSeriesModule,
  utilModule,
  apiModule,
  adminModule,
  alertsModule,
  appNotificationModule,
  serviceModule,
  filterModule,
  helpModule,
  equipmentListModule,
  equipmentESNModule,
  filterModule,
  equipmentFilterModule,
  directivesModule,
  devicesModule,
  assetDashboardModule,
  profileModule,
  ErrorsModule,
  browserPolicyModule,
  assetDetailsDashboardModule,
  SitesModules,
  equipmentUpdateModule,
  'ngResource',
  'ngSanitize',
  'ui.router',
  'ui.router.state.events',
  'ui.bootstrap',
  'ui.select',
  'ngTagsInput',
  'ngAnimate',
  'toastr',
  'ngCookies',
  'angular-jwt',
  'appSettingsModule',
  'angularjs-dropdown-multiselect',
  'ngCsv',
  'duScroll',
  'ncy-angular-breadcrumb',
  'colorpicker.module',
  'LocalStorageModule',
  'nya.bootstrap.select',
  'vs-repeat',
  'angular-ladda',
  'gettext',
  'dndLists',
  'angularMoment',
  'angularFileUpload',
  'xeditable',
  'angularjs-gauge',
  'nvd3',
]);

class AngularAppModule {
  init() {
    appModule
      /**
       * Default query string for the asset multi picker.
       * The query string is passed as a resolve into the AssetMultiPicker from some modules. For other modules, there should be a default or the angular injection error occurs
       */
      .constant('prefilter', {
        queries: [],
      })
      .constant('pickerSettings', {})
      .constant('browser', {
        supported:
          !(bowser.msie && bowser.version <= 11) && !(bowser.msedge && bowser.version < 16),
        name: bowser.name,
        version: bowser.version,
        osname: bowser.osname,
        osversion: bowser.osversion,
      })
      // Config
      .config([
        '$compileProvider',
        ($compileProvider) => {
          // production performance tweaks
          $compileProvider.debugInfoEnabled(false);
          $compileProvider.commentDirectivesEnabled(false);
          $compileProvider.cssClassDirectivesEnabled(false);
        },
      ])
      .config([
        '$qProvider',
        function ($qProvider) {
          const env_allowsErrorConsoleLog = [
            AppSettings.environments.local,
            AppSettings.environments.staging,
          ];
          if (!env_allowsErrorConsoleLog.includes(AppSettings.environment)) {
            $qProvider.errorOnUnhandledRejections(false);
          }
        },
      ])
      .config([
        '$httpProvider',
        function InterceptorConfig($httpProvider) {
          //disable IE ajax request caching
          /* $httpProvider.defaults.headers.get['If-Modified-Since'] = 'Mon, 26 Jul 1997 05:00:00 GMT';
          // extra
          $httpProvider.defaults.headers.get['Cache-Control'] = 'no-cache';
          $httpProvider.defaults.headers.get['Pragma'] = 'no-cache';
          */

          $httpProvider.defaults.headers.common = {
            'Cache-Control': 'no-cache',
            Pragma: 'no-cache',
          };

          // This is hack for angular not knowing how to use the browsers url for the base path
          $httpProvider.interceptors.push(($q) => {
            'ngInject';

            return {
              request: (config) => {
                if (config.url.charAt(0) === '/') {
                  config.url = `//${Auth.getUrl().host}/api${config.url}`;
                }

                return config;
              },
            };
          });

          $httpProvider.interceptors.push('authInterceptor');
          $httpProvider.defaults.headers['delete'] = {
            'content-type': 'application/json',
          };
        },
      ])
      .config(EquipmentRouteConfig)
      .config([
        '$stateProvider',
        function ($stateProvider) {
          $stateProvider.state('logoff', {
            url: '/logoff',
            template: '<p></p>',
            controller: function () {
              Auth.signUserOut();
            },
          });
        },
      ])
      .config(['$stateProvider', '$urlRouterProvider', IndexRouteConfig])
      .config(function ($breadcrumbProvider) {
        $breadcrumbProvider.setOptions({
          templateUrl: 'components/breadcrumbs/breadcrumbs.template.html',
        });
      })
      .controller('EquipmentImagesDeleteModalController', EquipmentImagesDeleteModalController)
      .controller('EquipmentImagesModalController', EquipmentImagesModalController)
      .controller('EquipmentController', EquipmentController)
      .controller('SaveFiltersConfirmModalController', SaveFiltersConfirmModalController)
      .controller('SaveFiltersModalController', SaveFiltersModalController)
      .controller('SavedFiltersDeleteModalController', SavedFiltersDeleteModalController)
      .controller('SavedFiltersModalController', SavedFiltersModalController)
      .controller('AppController', AppController)
      .controller('DateRangeController', DateRangeController)

      // Web-configured services
      .service('initialData', () => {
        let state = App.store.getState();
        return {
          currentUser: state.user,
          datapointDescriptors: state.user.datapointDescriptors,
          activeNotifications: state.user.activeNotifications,
        };
      })
      .service('appSettings', AppSettingsService)
      // Factories and services
      .service('equipmentSearchService', EquipmentSearchService)
      .service('conversionService', conversionService)
      .service('utilitySevice', UtilitySevice)
      .service('authService', authService)
      .factory('authInterceptor', AuthInterceptor)
      .service('TimezoneService', TimezoneService)
      .factory('equipmentSearchFactory', EquipmentSearchFactory)
      .service('equipmentDetailsService', EquipmentDetailsService)

      // Directives
      /**
       * the HTML5 autofocus property can be finicky when it comes to dynamically loaded
       * templates and such with AngularJS. Use this simple directive to
       * tame this beast once and for all.
       *
       * Usage:
       * <input type="text" autofocus>
       *
       * License: MIT
       */
      .directive('dateRange', [DateRangeDirective])
      .directive('equipmentFacetFilters', [EquipmentFacetFiltersDirective])
      .directive('equipmentFiltersSummary', [EquipmentFiltersSummaryDirective])

      .directive('pollButton', [PollButtonDirective])
      .directive('equipmentFilters', [EquipmentFiltersDirective])
      .directive('equipmentFullFilters', [EquipmentFullFiltersDirective])
      .directive('securityGroupsFilter', [SecurityGroupsFilterDirective])
      /**
       * Directive for the hamburger to toggle the side nav
       */
      .directive('toggleHelpNav', [ToggleHelpNavDirective])

      // Components
      .component('faultCsv', FaultCsvComponent)
      .component('equipmentDetailEdit', EquipmentDetailEditComponent)
      .component('equipmentDetails', EquipmentDetailsComponent);

    return this;
  }

  bootstrap() {
    angular.element(() => {
      angular.bootstrap(document, ['app']);
    });
  }
}

export default new AngularAppModule();
